import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconNotiWorksheet = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.7588 5.6C17.076 5.6 17.3331 5.85715 17.3332 6.17436V14.9833C17.3331 15.1229 17.2824 15.2578 17.1901 15.3627L15.8348 16.9016L14.6084 18.2174C14.4997 18.3339 14.3474 18.3999 14.1881 18.3999H7.24098C6.92377 18.3999 6.66663 18.1428 6.66663 17.8256V6.17436C6.66665 5.85716 6.92378 5.60002 7.24098 5.6H16.7588Z",
			fill: "#00ABFF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.03796,
			y: 7.73333,
			width: 7.87302,
			height: .965079,
			rx: .48254,
			fill: "#ECF9FE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.03796,
			y: 9.66354,
			width: 5.89206,
			height: .965079,
			rx: .48254,
			fill: "#ECF9FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4715 14.7172H17.3335V15.0914C17.3335 15.1612 17.3081 15.2287 17.2619 15.2811L14.7748 18.1074C14.6255 18.2771 14.4104 18.3743 14.1843 18.3743V15.0044C14.1843 14.8458 14.3129 14.7172 14.4715 14.7172Z",
			fill: "#A0E1FD"
		})
	] })
});
export default SvgIconNotiWorksheet;
